export interface AIOrchestratorConfig {
  maxRetries: number;
  retryDelay: number;
}

export const defaultOrchestratorConfig: AIOrchestratorConfig = {
  maxRetries: 3,
  retryDelay: 1000, // 1 second
};

